import React from 'react';
import { XIcon } from 'lucide-react';
const PROBLEMS = ['You spend hours preparing sessions before stepping onto court.', 'You constantly need effective drills for different training objectives.', 'Your exercises, notes, and progressions are scattered everywhere.', 'You need to adapt sessions for different players and pairs.', 'You see problems in matches but need the right task to correct them.', 'Your sessions need structure, progression, and competitive purpose.'];
export function Problems() {
  return <section aria-labelledby="problems-title" className="w-full bg-ivory px-4 py-8 sm:px-6" data-id="element-173" data-mp="2o4hy72slqt8j">
      <div className="mx-auto max-w-4xl text-center" data-id="element-174" data-mp="2j6ybdehu984z">
        <span className="font-head text-[11px] font-semibold uppercase tracking-wider text-urgent sm:text-xs" data-id="element-175" data-mp="2f4lab3e1dyej">
          The Coaching Reality
        </span>
        <h2 id="problems-title" className="mt-1 font-display text-2xl uppercase leading-tight text-charcoal sm:text-4xl" data-id="element-176" data-mp="hea6z1tgkenm">
          If you coach padel, you probably know these problems.
        </h2>

        <ul className="mx-auto mt-4 grid gap-2 text-left sm:grid-cols-2" data-id="element-177" data-mp="34t7qhd3qht4e">
          {PROBLEMS.map(item => <li key={item} className="flex items-start gap-2 rounded-lg border border-charcoal/10 bg-white px-3 py-2 text-[13px] leading-snug text-charcoal" data-id="element-178" data-mp="2vqgcb5jh4j92">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-urgent" aria-hidden="true" data-id="element-179" data-mp="3nhmia2lvlb69" />
              {item}
            </li>)}
        </ul>

        <p className="mt-5 font-display text-xl uppercase leading-tight text-brand-dark sm:text-2xl" data-id="element-180" data-mp="3sfxsieg31np0">
          How many more sessions do you want to keep building from scratch?
        </p>
      </div>
    </section>;
}